/**
 * Products Page - Platform subscription products
 */

import React from 'react';

const Products: React.FC = () => {
  const products = [
    { name: 'Mango Starter', price: 0, description: 'Free tier for new businesses' },
    { name: 'Mango Growth', price: 29, description: 'For growing businesses' },
    { name: 'Mango Pro', price: 79, description: 'Full featured platform' },
    { name: 'Mango Enterprise', price: 199, description: 'Custom enterprise solutions' },
  ];

  return (
    <div>
      <h1 style={styles.title}>Products</h1>
      <p style={styles.subtitle}>Platform subscription products</p>
      
      <div style={styles.grid}>
        {products.map((product, index) => (
          <div key={index} style={styles.card}>
            <h3 style={styles.productName}>{product.name}</h3>
            <div style={styles.price}>
              ${product.price}<span style={styles.priceUnit}>/mo</span>
            </div>
            <p style={styles.description}>{product.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  title: {
    fontSize: '2rem',
    fontWeight: 700,
    color: '#fff',
    margin: 0,
  },
  subtitle: {
    color: '#9ca3af',
    marginTop: '5px',
    marginBottom: '30px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '20px',
  },
  card: {
    background: '#1a1a2e',
    borderRadius: '12px',
    padding: '24px',
    border: '1px solid #252540',
  },
  productName: {
    color: '#FFA500',
    margin: '0 0 15px 0',
  },
  price: {
    fontSize: '2rem',
    fontWeight: 700,
    color: '#fff',
  },
  priceUnit: {
    fontSize: '1rem',
    color: '#9ca3af',
    fontWeight: 400,
  },
  description: {
    color: '#9ca3af',
    marginTop: '10px',
  },
};

export default Products;
